<template>
  <div class="popover-menu">
    <button @click="open = !open" :class="[{ active: open }, { notOnTrip: isNotOnTrip }]">{{ activator }}</button>
    <div v-if="open" class="menu">
      <ul>
        <li v-for="item in items" :key="`menu${item.id}`">
          <router-link :to="`/mac/${item.id}${queryParams}`"> {{ item.id }} {{ item.displayType }}</router-link>
          {{ item.amplifier ? '&#x1f508;' : '' }}
        </li>
      </ul>
      <button @click="open = !open">Lukk</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminVehicleDropdown',
  props: {
    activator: {
      type: Number,
      required: true,
    },
    isNotOnTrip: {
      type: Boolean,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    marketingTestMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    queryParams() {
      const base = '?testing=true'
      return this.marketingTestMode ? base + '&unpublished=true' : base
    },
  },
}
</script>

<style scoped>
.popover-menu {
  display: inline-block;
  position: relative;
}

.popover-menu button.active {
  border: 2px solid royalblue;
}

.popover-menu .menu {
  margin-left: 2px;
  margin-top: 2px;
  position: absolute;
  background-color: rgba(250, 250, 250, 0.9);
  border: thin solid grey;
  padding: 4px 8px;
  z-index: 100;
}

.popover-menu .menu ul {
  list-style: none;
  padding-left: 0;
}

.popover-menu .menu ul li {
  padding-bottom: 4px;
  white-space: nowrap;
}

.notOnTrip {
  color: red;
}
</style>